import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { LoginComponent } from './login';

@NgModule({
  declarations: [
    LoginComponent,
  ],
  imports: [
    IonicModule
  ],
  exports: [
    LoginComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class LoginComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/login/login.module.ts